import React from "react";
import PropTypes from "prop-types";
import SoluspotsCoins from "../images/soluspots-coins.svg";

/**
 * Composant Badge
 *
 * Affiche une icône principale avec une pastille indiquant un nombre ou le symbole ∞.
 * La couleur de la pastille est définie en fonction de la valeur (si numérique).
 *
 * Props :
 * - value : (number | string) La valeur à afficher dans la pastille.
 *            Vous pouvez passer "subscription" pour afficher ∞.
 */
const Badge = ({ value }) => {
  let displayValue;
  let colorClass = "";
  let sizeClass = "";

  if (value === "subscription") {
    displayValue = "∞";
    colorClass = "ssscoins--green";
    sizeClass = "ssscoins--big";
  } else if (typeof value === "number") {
    displayValue = value;
    if (value < 3) {
      colorClass = "ssscoins--red";
    } else if (value < 5) {
      colorClass = "ssscoins--orange";
    } else {
      colorClass = "ssscoins--green";
    }
  } else {
    displayValue = value;
    colorClass = "ssscoins--default";
  }

  return (
    <div className="ssscoins-container">
      <img
        src={SoluspotsCoins}
        alt="Icône principale"
        className="ssscoins-main-icon"
      />
      <span className={`ssscoins ${colorClass} ${sizeClass}`}>
        {displayValue}
      </span>
    </div>
  );
};

Badge.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default Badge;
